export default __webpack_public_path__ + "static/media/loading.d63a8c7e.gif";